<app-auth-window subtitle="auth.subtitle_login">
  @if (expired() && !error()) {
    <div class="cmc-auth-alert cmc-auth-alert--info" role="status">
      <mat-icon aria-hidden="true">schedule</mat-icon>
      <span>{{ 'auth.session_expired' | translate }}</span>
    </div>
  }
  @if (error(); as message) {
    <div class="cmc-auth-alert" role="alert">
      <mat-icon aria-hidden="true">error</mat-icon>
      <span>{{ message }}</span>
    </div>
  }

  <form class="cmc-auth-form" [formGroup]="form" (ngSubmit)="login()" novalidate>
    <div class="cmc-auth-field" [class.is-invalid]="invalid('username')">
      <label class="cmc-auth-field__label" for="loginUsername">{{ 'auth.username' | translate }}</label>
      <div class="cmc-auth-field__control">
        <mat-icon aria-hidden="true">person</mat-icon>
        <input id="loginUsername" formControlName="username" autocomplete="username" autocapitalize="none"
          spellcheck="false" [attr.aria-invalid]="invalid('username')">
      </div>
      @if (form.controls.username.touched && form.controls.username.invalid) {
        <span class="cmc-auth-field__error">{{ 'auth.required' | translate }}</span>
      }
    </div>

    <div class="cmc-auth-field" [class.is-invalid]="invalid('password')">
      <label class="cmc-auth-field__label" for="loginPassword">{{ 'auth.password' | translate }}</label>
      <div class="cmc-auth-field__control">
        <mat-icon aria-hidden="true">lock</mat-icon>
        <input #passwordInput id="loginPassword" formControlName="password" autocomplete="current-password"
          [type]="showPassword() ? 'text' : 'password'" [attr.aria-invalid]="invalid('password')">
        <button type="button" class="cmc-auth-icon-button" (click)="showPassword.set(!showPassword())"
          [attr.aria-pressed]="showPassword()"
          [attr.aria-label]="(showPassword() ? 'auth.hide_password' : 'auth.show_password') | translate"
          [matTooltip]="(showPassword() ? 'auth.hide_password' : 'auth.show_password') | translate">
          <mat-icon>{{ showPassword() ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
      </div>
      @if (form.controls.password.touched && form.controls.password.invalid && !error()) {
        <span class="cmc-auth-field__error">{{ 'auth.required' | translate }}</span>
      }
    </div>

    <div class="cmc-auth-row">
      <label class="cmc-auth-check">
        <input type="checkbox" formControlName="rememberMe">
        <span class="cmc-auth-check__box" aria-hidden="true"><mat-icon>check</mat-icon></span>
        {{ 'auth.remember_me' | translate }}
      </label>
      <a class="cmc-auth-link" routerLink="/auth/forgot-password">{{ 'auth.forgot_password' | translate }}</a>
    </div>

    <button type="submit" class="cmc-auth-button cmc-auth-button--submit" [disabled]="submitting()"
      [attr.aria-busy]="submitting()">
      {{ 'auth.sign_in' | translate }}
      <mat-icon aria-hidden="true">{{ submitting() ? 'progress_activity' : 'arrow_forward' }}</mat-icon>
    </button>
  </form>
</app-auth-window>
